'use strict';

var Decorator = {};

/**
 * Expects an input-Element an (optional) icon and an (optional) color.
 * The icon is then added at the end of the input-field and colored
 * if a color was specified. If you want to add just a color, enter an empty string
 * for the icon.
 *
 * Uses UBold-specific classes and can't be expected to work with other themes.
 * @param {[jQuery Element]} $element       Must be an input-field
 * @param {[Css-class]} icon                An icon-class is expected. any icon theme works.
 *                                          An expample would be "fa fa-user"
 *                                          most common use would be "glyphicon glyphicon-ok",
 *                                          "glyphicon glyphicon-warning", "glyphicon glyphicon-remove"
 * @param {[css-class]} color               One of the following classes (or none) is expected:
 *                                          "has-success", "has-warning", "has-error"
 */
Decorator.addInputDecoration = function ($element, icon, color) {
    $element.parent('div').addClass('has-feedback ' + color);
    var ID = $element.attr('id') + '-decoration';
    if (document.getElementById(ID) === null && icon !== '') {
        $element.after('<span id="' + ID + '" class="' + icon + ' form-control-feedback"></span>');
    }
};

/**
 * Removes all classes and tags added by Decorator.addInputDecoration. Removes the classes
   "has-feedback", "has-success", "has-warning" and "has-error" from the parent div, so be carefull
   with this function, if you use theses classes in divs by yourself.
 * @param  {[jQuery-Element]} $element Must be the input-field to which applied "addInputDecoration" before.
 */
Decorator.removeInputDecoration = function ($element) {
    $element.parent('div').removeClass('has-feedback has-success has-warning has-error');
    var ID = '#' + $element.attr('id') + '-decoration';
    if ($element.siblings().filter(ID) != null) {
        $element.siblings().filter(ID).remove();
    }
};

Decorator.flash = function ($element) {
    if ($element.hasClass('flashing')) {
        return;
    }
    if ($element.attr('type') === 'checkbox') {
        $element = $element.parent();
    }
    var bgcolor = $element.css('background-color');
    $element.fadeOut(400, function () {
        $element.css({ 'background-color': 'red' });
        $element.addClass('flashing');
        $element.fadeIn(400, function () {
            $element.css({ 'background-color': bgcolor });
            $element.removeClass('flashing');
        });
    });
};

/**
 * Removes all classes for marking errors and tags that have been added to display server Errros.
 * @param  {[jQuery-Element]} $element The input-field which should be cleaned
 */
Decorator.cleanupErrors = function ($element) {
    $element.removeClass('parsley-error');
    $element.parent().removeClass('has-error');
    $element.parent('div').removeClass('has-feedback has-success has-warning has-error');
};

/**
 * Adds a spinning wheel to an element to visualize a loading/working process
 * @param element The element where the spinning wheel should be added
 */
Decorator.disableElement = function (element) {
    $(element).append('<div id="ct-loading-screen" class="disable-element"><div class="loader-1"></div></div>');
};

/**
 * Removes the spinning wheel
 * @param element The element where the spinning wheel should be removed
 */
Decorator.enableElement = function (element) {
    var disabledElement = $(element).find('.disable-element');
    disabledElement.remove();
};

var isLoading = {};

function watchLoading(el) {
    if (!isLoading[el.selector]) {
        return;
    }

    if (!$('div.disable-element').length) {
        Decorator.disableElement(el);
    }

    setTimeout(function () {
        watchLoading(el);
    }, 200);
}

Decorator.displayLoading = function (visible, container) {
    var el = container || '.content';
    el = $(el);

    if (visible) {
        Decorator.disableElement(el);
        isLoading[el.selector] = true;
        watchLoading(el);
    } else {
        isLoading[el.selector] = false;
        Decorator.enableElement(el);
    }
    return true;
};
/**
 * Adds validation error messages to an input field.
 * @param  {[jQuery-Element]} $element The input-field which should be decorated with error message.
 * @param  {[Int]} id used to identify the errors list
 * @param  {[Array]} array of message to be displayed.
 */
Decorator.addValidationErrorMessages = function ($element, id, msgs) {
    var list = "<ul class='parsley-errors-list filled' id='parsley-id-" + id + "'" + '> ';
    msgs.forEach(function (msg) {
        list += "<li class='parsley-required'>" + msg + '</li>';
    });
    list += '</ul>';
    if ($($element.selector).parent().hasClass('input-group')) $($element.selector).parent().after(list);
    else $($element.selector).after(list);
    $($element.selector).addClass('parsley-error');
};

/**
 * Removes all validation error messages that have been added to display validation errros.
 * @param  {[jQuery-Element]} $element The input-field which should be cleaned
 * @param  {[Int]} id used to identify the errors list - <UL> element.
 */
Decorator.removeValidationErrorMessages = function ($element, id) {
    var parent = $element.parent();
    if (parent.hasClass('input-group')) {
        var selStr = '*' + ' ~ #parsley-id-' + id;
        $(selStr).remove();
    } else {
        var selStr = '#' + $element.attr('id') + ' ~ #parsley-id-' + id;
        $(selStr).remove();
    }
};

module.exports = Decorator;
